import { getConfiguracionesDeSegmentosDeFolios } from 'api/configuracion/configuracionesDeFolios';
import {
  deleteOrigenDeCredito,
  getOrigenesDeCredito,
  patchOrigenDeCredito,
  postOrigenDeCredito,
} from 'api/pae/origenesDeCredito';
import { getSistemas } from 'api/recaudacion/sistemas';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import React from 'react';
import { capitalize } from 'utils/normalizers';
import { getPadrones } from 'utils/padrones';

const catalogs = [
  {
    permission: 'sistemas',
    get: getSistemas,
    formItemName: 'sistema',
  },
  {
    permission: 'padrones',
    get: getPadrones,
    formItemName: 'tipo_de_padron',
  },
  {
    permission: 'segmentos_de_folios',
    get: getConfiguracionesDeSegmentosDeFolios,
    formItemName: 'configuracion_de_foliador_de_ejecucion',
  },
];

export const permissionConfig = {
  permissionModel: 'origendelcreditopae',
  catalogsModels: catalogs.map((c) => c.permission),
};

// eslint-disable-next-line react/prop-types
const OrigenesDeCredito = ({ permission }) => (
  <PlainCRUD
    title="Origen de Crédito"
    get={getOrigenesDeCredito}
    post={postOrigenDeCredito}
    patch={patchOrigenDeCredito}
    delete={deleteOrigenDeCredito}
    permission={permission}
    catalogs={catalogs}
    disabledStateField
    tableProps={{
      allowColumnSelector: false,
      deleteText: 'Cancelar',
    }}
    fields={[
      {
        ...defaultFields.descripcion,
        normalize: (value) => capitalize(value),
      },
      {
        name: 'tipo_de_padron',
        label: 'Tipo de Padrón',
        useCatalog: true,
        type: 'select',
        colWidth: 120,
        disabledOnEdit: true,
        filter: (e) => e.usado_en_ejecuciones,
      },
      {
        name: 'sistema',
        label: 'Sistema',
        useCatalog: true,
        type: 'select',
        colWidth: 120,
        disabledOnEdit: true,
      },
      {
        name: 'configuracion_de_foliador_de_ejecucion',
        label: 'Foliador',
        useCatalog: true,
        type: 'select',
        colWidth: 120,
      },
    ]}
  />
);

export default OrigenesDeCredito;
